import Resource, { createResourceHook } from '@tabeo/resync'
import api from '@tabeo/sharpei/utils/api'
import normalize from './normalizers/lead'

const subresources = `subResource=${[
  'product',
  'appointment',
  'merchants',
].join('&subResource=')}`

class Leads extends Resource {
  getInitialData() {
    return {
      items: null,
      totalCount: 0,
    }
  }

  getInitialConfig() {
    return {
      refreshInterval: 15 * 1000,
    }
  }

  async fetch(query) {
    const {
      conditions = [],
      searchQuery = query,
      limit = 10,
      offset = 0,
      orderBy: { field, direction } = { field: 'id', direction: 'desc' },
    } = this.params

    const order = `&order=${field}:${direction}`
    const jsonConditions = `&jsonConditions=${encodeURIComponent(
      JSON.stringify(conditions)
    )}`
    const pagination = `&limit=${limit}&offset=${offset}`
    const endpoint = searchQuery
      ? `/lead-search?${subresources}${order}&searchPhrase=${searchQuery}`
      : `/leads?${subresources}${order}`

    const {
      data: { leads },
      totalCount,
    } = await api.get(`${endpoint}${jsonConditions}${pagination}`, {
      responseDataPath: 'data',
    })

    const data = {
      totalCount,
      items: leads.map(o => normalize(o)),
    }

    this.data = data

    return data
  }
}

export default Leads
export const useLeads = createResourceHook(Leads)
